<template>
  <b-row align-v="start" class="pet-products product pl-2 pr-1" no-gutters>
    <b-col v-if="productImageUrl" cols="auto">
      <b-img alt="" class="img-border product-image" :src="productImageUrl" />
    </b-col>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <b-col class="ml-2">
      {{ item.product.name }}
      <div v-if="item.product.description" v-html="item.product.description"></div>
    </b-col>
    <b-col>
      <h3 class="my-0 text-right">
        <span :style="{ textDecoration: Number(item.subtotal) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }">
          {{ $n(item.subtotal, 'currency') }}
        </span>
        <span v-if="Number(item.subtotal) !== Number(item.subtotal - item.discount)" class="ml-1">
          <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
          <span v-else>{{ $t('components.totals.free') }}</span>
        </span>
      </h3>
      <b-button block class="m-0 p-0 text-right" variant="link" @click="$emit('remove-item', item.id)">{{ $t('dp.generic.remove') }}</b-button>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'MembershipSubscriptionProduct',
  props: {
    item: {
      type: Object,
      required: true,
    },
    productImageUrl: {
      type: String,
      required: false,
      default: null
    },
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
</style>
